module.exports = __webpack_public_path__ + "img/oscleton-sdk.ed83f2d9.png";